// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2gYS_","empty":"ModalGraph_empty__SB7fM"};